import * as React from 'react';

export const Spacer = () => <div className="root" />;

export default Spacer;



// WEBPACK FOOTER //
// ./src/components/Spacer.tsx